import { DynamicFormItem } from '@ispm/dynamic-form/classes/dynamic-form-item.class';
import { IdynamicFormItem, IDynamicFormPayload } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import { PlaceholderModalLoaderPayload } from '@ispm/layout/classes/placeholder-modal-loader-payload';
import { DEFAULT_LOADER, LOADER_TYPES } from "@ispm/core/constants/core-ui-constants";
import { IDynacmiFormTableUniqueBy } from '../interfaces/IDynacmiFormTableUniqueBy.interface';
import { IReflect } from '../interfaces/reflect.interface';

export class DynamicFormModalPayload implements IDynamicFormPayload {
  formId: string;
  formConfig: Array<DynamicFormItem>;
  formReflects?: IReflect[];
  formData: any;
  submitButtonText: string;
  cancelButtonText: string;
  cssClass: string;
  classes: string;
  overrides: { [prop: string]: Partial<IdynamicFormItem>};
  editMode: boolean;
  popupMode: boolean = true;
  disabled: boolean = false;
  listenToDataChange: boolean = false;
  loaderType: LOADER_TYPES = DEFAULT_LOADER;
  showEditIcon: boolean = false;
  updatedFieldsContext: string;
  updatedFieldsContextType: string;
  additionalSearchValues: any;
  flagDiffFieldsOnUpdate: boolean;
  appendFormId: string;
  groupBy: string;
  orderBy: string;
  subGroupBy: string;
  groupOrderAttribute: string;
  skipAsyncValidation?: boolean;
  skipInit?: boolean;
  formInitialDisbale: boolean;
  uniqueBy?: IDynacmiFormTableUniqueBy;
  additional?:{[key:string]:any};
  disabledFields?: string[];
  note: string;
  allowDuplicate?: boolean;
  validateDuplicateByField?: string;
  globalConfigurations?: any;

  public static builder() {
    return new this();
  }

  setFormId(formId: string) {
    this.formId = formId;
    return this;
  }

  setFormReflects(formReflects: Array<IReflect>) {
    this.formReflects = formReflects;
    return this;
  }

  setSubmitButtonText(submitButtonText: string) {
    this.submitButtonText = submitButtonText;
    return this;
  }
  setCancelButtonText(cancelButtonText: string) {
    this.cancelButtonText = cancelButtonText;
    return this;
  }

  setFormConfig(formConfig: Array<DynamicFormItem>) {
    this.formConfig = formConfig;
    return this;
  }

  setEditMode(editMode: boolean) {
    this.editMode = editMode;
    return this;
  }

  setFormData<T= any>(formData: T) {
    this.formData = formData;
    return this;
  }

  setOverrides(overrides) {
    this.overrides = overrides;
    return this;
  }

  setCssClass(cssClass) {
    this.cssClass = cssClass;
    return this;
  }

  setPopupMode(mode: boolean) {
    this.popupMode = mode;
    return this;
  }

  setDisabled(disabled: boolean) {
    this.disabled = disabled;
    return this;
  }

  setListenToDataChange(listenToDataChange: boolean) {
    this.listenToDataChange = listenToDataChange;
    return this;
  }

  setLoaderType(loader: LOADER_TYPES) {
    this.loaderType = loader;
    return this;
  }
  setFormContext(updatedFieldsContext: any): any {
    this.updatedFieldsContext = updatedFieldsContext;
    return this;
  }

  setFormContextType(updatedFieldsContextType: string): any {
    this.updatedFieldsContextType = updatedFieldsContextType;
    return this;
  }


  setAdditionalSearchValues(additionalSearchValues: any) {
    this.additionalSearchValues = additionalSearchValues;
    return this;
  }

  setFlagDiffFieldsOnUpdate(flagDiffFieldsOnUpdate: boolean) {
    this.flagDiffFieldsOnUpdate = flagDiffFieldsOnUpdate;
    return this;
  }

  setFormInitialDisable(formInitialDisbale: boolean){
    this.formInitialDisbale = formInitialDisbale;
    return this;
  }

  setDisabledFields(fields: string[]) {
    this.disabledFields = fields;
    return this;
  }

  setNote(note: string) {
    this.note = note;
    return this;
  }

  setAllowDuplicate(allowDuplicate: boolean) {
    this.allowDuplicate = allowDuplicate;
    return this;
  }

  setValidateDuplicateByField(validateDuplicateByField: string) {
    this.validateDuplicateByField = validateDuplicateByField;
    return this;
  }

  setGlobalConfigurations(globalConfigurations: any){
    this.globalConfigurations = globalConfigurations;
    return this;
  }
}
